// Version of the scoring rules. Every stored result carries it (`scoring_version`)
// so a report can say which rules produced its numbers, and old results are never
// silently rescored. Bump it whenever a change here can alter any score, band,
// resolution or aggregate for the same input; the golden tests in
// scoring-version.test.ts fail first so the bump is deliberate.
//
// Format: "<engine lineage>.<revision>". "xray.1" = X-Ray-Team assessment-engine
// @ a405b1b, lifted unchanged.
export const SCORING_VERSION = "xray.1";

export type ScoringVersion = typeof SCORING_VERSION;

// The column stamped next to any persisted score or aggregate.
export function scoringStamp(): { scoring_version: ScoringVersion } {
  return { scoring_version: SCORING_VERSION };
}
